import Coffeeshop from '../assets/projects/coffeeshop.png'
import Hirejob from '../assets/projects/hirejob.png'
import Fazzpay from '../assets/projects/fazzpay.png'
import Tickitz from '../assets/projects/tickitz.png'
import CoffeeMobile from '../assets/projects/coffeemobile.jpeg'
import VirtualTour from '../assets/projects/virtualtour.png'

export const data = [
    {
        id: 1,
        projectName: "Coffee Shop Web",
        name: "React JS Application",
        description: "Coffee Shop is a website application for ordering coffee and food.",
        image: Coffeeshop,
        github: "https://github.com/ryanagungsamudra/YANNN-COFFEE-SHOP",
        live: "https://yannncoffee.netlify.app",
    },
    {
        id: 2,
        projectName: "Hire Job App",
        name: "React JS Application",
        description: "Hiring Job is a website for job seekers looking for work and also for employer looking for worker.",
        image: Hirejob,
        github: "https://github.com/ryanagungsamudra/HireApp-FE",
        live: "https://hirejob-array.vercel.app/",
    },
    {
        id: 3,
        projectName: "Fazzpay",
        name: "Next JS Application",
        description: "Fazzpay is a digital financial service which acts as a digital payment or E-Wallet.",
        image: Fazzpay,
        github: "https://github.com/ryanagungsamudra/FAZZPAY",
        live: "https://yannnfazzpay.vercel.app/",
    },
    {
        id: 4,
        projectName: "Tickitz",
        name: "Next JS Application",
        description: "Tickitz is a website for booking a movie ticket, and also provide information about movies and upcoming movies.",
        image: Tickitz,
        github: "https://github.com/ryanagungsamudra/Tickitz-FE",
        live: "https://tickitz-stringify.vercel.app/",
    },
    {
        id: 5,
        projectName: "Coffee Shop Mobile",
        name: "React Native Application",
        description: "Coffee Shop is a mobile application (android & ios) for ordering coffee and food.",
        image: CoffeeMobile,
        github: "https://github.com/ryanagungsamudra/YANNN-COFFEE-SHOP-MOBILE",
        live: "https://drive.google.com/file/d/1SKfoa8qEeTilyXvMpFRS9qi3ErmEOibL/view?usp=sharing",
    },
    {
        id: 6,
        projectName: "FTM Tour",
        name: "Virtual Tour Application",
        description: "Web Based 360° Virtual Tour Application and 3D Rock Model",
        image: VirtualTour,
        live: "http://virtualtourftm.epizy.com/",
    },
]